import React from 'react';
import cn from 'classnames';
import { useTheme, useMergeClasses } from '../../../../../../theme';
import SegmentTab from '../SegmentTab/SegmentTab';
import FullscreenDialogClose from '../../../../../../FullscreenDialog/components/Close/Close';
const SegmentTabs = ({ classes, title, segments, activeSegment, sticky, center, scrollToActive, isCompact, onClose, onSegmentClick }) => {
    const { SegmentTabs: defaultClasses } = useTheme('Shared').SegmentTabs;
    const css = useMergeClasses(defaultClasses, classes);
    const handleSegmentClick = (e) => {
        var _a;
        if (scrollToActive) {
            (_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ inline: 'center', block: 'center' });
        }
    };
    return (React.createElement("div", { className: cn(css.wrapper, {
            [css.wrapper_sticky]: sticky,
            [css.wrapper_center]: center,
            [css.wrapper_withClose]: onClose
        }) },
        React.createElement("div", { id: "segment-tabs", className: css.inner },
            title && React.createElement("div", { className: css.title }, title),
            React.createElement("div", { className: css.segments }, segments.map((segment, index) => (React.createElement("div", { key: segment.id, onClick: handleSegmentClick },
                React.createElement(SegmentTab, { index: index + 1, isActive: segment.id === activeSegment, isCompact: isCompact !== null && isCompact !== void 0 ? isCompact : segments.length > 2, onClick: () => onSegmentClick(segment.id), segment: segment, count: segment.countSeatsSelected }))))),
            onClose && React.createElement(FullscreenDialogClose, { onClose: onClose, closeClassName: css.close }))));
};
export default SegmentTabs;
